import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../core/user.service';
import { AuthService } from '../core/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { DatePipe } from '@angular/common';
import { log } from 'util';
import { forEach } from '@angular/router/src/utils/collection';



@Component({
  selector: 'page-user',
  templateUrl: 'user.component.html',
  styleUrls: ['user.scss']
})
export class UserComponent implements OnInit{


  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  bookingList : AngularFireList<any>;

  dataSource;

  displayedColumns = ['name', 'startDate', 'endDate', 'budget', 'phone','email', 'heads', 'interests'];

  constructor(
    public userService: UserService,
    public authService: AuthService,
    //private route: ActivatedRoute,
    private location : Location,
    private firebase: AngularFireDatabase, 
    public datepipe: DatePipe
  ) {

  }

  ngOnInit(): void {
    //this.route.data.subscribe(routeData => {
      //let data = routeData['data'];
      // if (data) {
      //   this.user = data;
      // }
    //})






    var packageBookingList = []; 

    var currentDate = new Date();

    var refactorStartDate = new Date(); 

    this.bookingList = this.firebase.list('PACKAGE_INQUIRY')

    //this.bookingList.query.orderByChild('startDate').limitToFirst(10);

    this.bookingList.snapshotChanges().subscribe(item => {
      item.forEach(element => {
        var y = element.payload.toJSON();
        packageBookingList.push(y);
      })

        packageBookingList.forEach( (item, index) => {


          if(item.startDate){
            var dateString = item.startDate;
            dateString.split('/');
            var newDate = dateString[3]+dateString[4]+'/'+ dateString[0]+dateString[1]+'/'+ dateString[6]+dateString[7]+dateString[8]+dateString[9]
            item.startDate = new Date(newDate);

            refactorStartDate = item.startDate;


        //  if(refactorStartDate < currentDate){
        //   console.log("date item inner",refactorStartDate);
        // debugger
        // console.log(index)
      
        //   //packageBookingList.splice(index, 100);
        // }

         


          }
          else{
            item.startDate = new Date(Date.parse(Date()));
          }

          if(item.endDate){
            var dateString = item.endDate;
            dateString.split('/');
            var newDate = dateString[3]+dateString[4]+'/'+ dateString[0]+dateString[1]+'/'+ dateString[6]+dateString[7]+dateString[8]+dateString[9]
            item.endDate = new Date(newDate);
          }
          else{
            item.endDate = new Date(Date.parse(Date()));
          }
        })


        // packageBookingList.forEach( (item, index) => {
        //   debugger
        //  // console.log("date item inner",refactorStartDate);
        //  // console.log("date item indsdsner",item.startDate);

        //   console.log("dd",refactorStartDate);
        //   console.log("dsdsx", currentDate);

        //    if(refactorStartDate < currentDate){
         
        //   console.log("date item indsdsner",item.startDate);
        // debugger
        // console.log(index)
      
        //   packageBookingList.splice(index, 100);
        // }

        // });

      this.dataSource = new MatTableDataSource(packageBookingList.reverse());
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    })
  



  }

  

  logout(){
    this.authService.doLogout()
    .then((res) => {
      this.location.back();
    }, (error) => {
      console.log("Logout error", error);
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Administrator/Desktop/Hotel-Data/src/app/user/user.component.ts